import ReactGA from 'react-ga'
import { createBrowserHistory } from 'history'

const TRACKING_ID = process.env.REACT_APP_GA || 'UA-163565237-2'
const REACT_APP_GA_DEBUG = process.env.REACT_APP_GA_DEBUG === 'true'

// Initial ReactGA
ReactGA.initialize(TRACKING_ID, {
  debug: REACT_APP_GA_DEBUG
})

ReactGA.pageview(window.location.pathname + window.location.search)

const history = createBrowserHistory()

// Initialize google analytics page view tracking
// Referrence: https://github.com/react-ga/react-ga/wiki/
history.listen(location => {
  // Update current page
  const pathname = location.pathname
  const search = location.search
  ReactGA.set({ page: pathname })
  // Record a pageview for the given page
  ReactGA.pageview(pathname + search)
})

export default history
